import React from 'react';

const PlatformRule: React.FC = () => {
    return (
        <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
            <iframe
                src="https://rules-center.meituan.com/rules?commonType=29"
                style={{ width: '100%', height: '100%', border: 'none' }}
            />
        </div>
    );
};

export default PlatformRule;
